import React from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'

const IconButtonGrouped = styled(Box)(`
    margin-left:10px;
    box-sizing: border-box;
    padding:0 5px;
    border-radius: 4px;
    height: 35px;
    min-width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px #D8D8D6 solid;
    & svg { margin: 0 5px; }
    & button {
      line-height: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
    }
    & button.active svg path, & button:hover svg path {
      fill: #095BBD;
    }
    & button:active svg path {
      fill: #686867;
    }
`)

const Table = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.4165 16.5827V3.41602H16.5832V16.5827H3.4165ZM4.49984 6.95768H15.4998V4.49935H4.49984V6.95768ZM4.49984 15.4993H6.66005V8.04102H4.49984V15.4993ZM13.3396 15.4993H15.4998V8.04102H13.3396V15.4993ZM7.74338 15.4993H12.2563V8.04102H7.74338V15.4993Z'
        fill='#686867'
      />
    </svg>
  )
}

const Graph = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.9998 15.5827V10.4962H15.5832V15.5827H12.9998ZM8.70817 15.5827V4.41602H11.2915V15.5827H8.70817ZM4.4165 15.5827V8.33602H6.99984V15.5827H4.4165Z'
        fill='#686867'
      />
    </svg>
  )
}

const GraphGridTab = ({ show, onClick }) => {
  return (
    <IconButtonGrouped>
      <button className={show === 'graph' ? 'active' : ''} onClick={() => onClick('graph')}>
        <Graph />
      </button>
      <button className={show === 'table' ? 'active' : ''} onClick={() => onClick('table')}>
        <Table />
      </button>
    </IconButtonGrouped>
  )
}

export default GraphGridTab
